const icons = {};
icons.block = <svg width="20px" height="20px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
	<path d="M47.612,40.008l-19.999,0l0,-32.016l13.566,0l6.433,0.023l0,31.993Z" fill="#97eaff" fillRule="nonzero" />
	<path d="M20.383,40l-20.036,0l0,-32l20.036,0.019l0,31.981Z" fill="#00b5e2" fillRule="nonzero" />
</svg>;

export default icons;
